// helpers/axiosHeaders.js
import globalAxios from "@/services/global-axios";

export function updateAxiosHeadersFromStorage() {
  const country = JSON.parse(localStorage.getItem("country"));
  const currencyId = localStorage.getItem("currencyId");

  if (country?.id) {
    globalAxios.defaults.headers["country-id"] = country.id;
  }

  if (currencyId) {
    globalAxios.defaults.headers["currency-id"] = currencyId;
  }
}
